import { useEffect, useState } from "react";
import { useUserContext } from "../useUserContext";
import { subscribeToConversations } from "@/app/_firebase/messages";
import { Conversation } from "@/app/@types/message";

// Last snapshot per tenant so a revisit to Messages paints the list straight
// away instead of skeletons, then the listener refreshes it.
const conversationsCache = new Map<string, Conversation[]>();

const useConversations = () => {
  const user = useUserContext();
  const messagingEnabled = user.settings.enableClientMessaging;
  const cached = conversationsCache.get(user.uid);
  const [conversations, setConversations] = useState<Conversation[]>(
    cached ?? []
  );
  const [isLoading, setIsLoading] = useState(!cached);

  useEffect(() => {
    if (!messagingEnabled) {
      setConversations([]);
      setIsLoading(false);
      return;
    }

    const unsubscribe = subscribeToConversations(user.uid, (data) => {
      conversationsCache.set(user.uid, data);
      setConversations(data);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, [user.uid, messagingEnabled]);

  return { conversations, isLoading };
};

export default useConversations;
